/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { memo } from 'react';
import Link from 'next/link';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { CloseIcon, CompanyLogo, RightArrow } from '@components/svgs';
import { CTAButton } from '@components/CTAButton';
import styles from './MobileNavBar.module.scss';

interface IMobileNavBarProps {
  routes: { label: string; path: string }[];
  onHandleCloseClick: () => void;
  isMounted: boolean;
}

export const MobileNavBar = memo<IMobileNavBarProps>(
  ({ routes, onHandleCloseClick, isMounted }) => {
    const router = useRouter();

    return (
      <div
        className={classnames(styles.mobileNavContainer, {
          [styles.mountedStyle]: isMounted,
          [styles.unmountedStyle]: !isMounted,
        })}
      >
        <div>
          <div className={styles.mobileNavContainerHeader}>
            <CompanyLogo
              onClick={() => {
                onHandleCloseClick();
                router.push('/');
              }}
              width="13.3rem"
            />

            <div onClick={onHandleCloseClick}>
              <CloseIcon style={{ cursor: 'pointer' }} fontSize="large" />
            </div>
          </div>
          <div className={styles.mobileNavContainerLinks}>
            {routes.map(({ label, path }) => (
              <Link onClick={onHandleCloseClick} key={label} href={path}>
                <span>{label}</span>
                <RightArrow />
              </Link>
            ))}
            {[{ label: 'Schedule a demo', path: '/schedule-a-demo' }].map(({ label, path }) => (
              <Link onClick={onHandleCloseClick} key={label} href={path}>
                <span>{label}</span>
                <RightArrow />
              </Link>
            ))}
          </div>
        </div>
        <div className={styles.demoContainer}>
          <CTAButton variant="contained" className={styles.button}>
            <Link href="/schedule-a-demo">Schedule a demo</Link>
          </CTAButton>
        </div>
      </div>
    );
  },
);

MobileNavBar.displayName = 'MobileNavBar';

export default MobileNavBar;
